"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetApprovalsStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const ramda_1 = require("ramda");
class AssetApprovalsStore {
    constructor() {
        this.assets = {
            value: []
        };
        this.asset = {};
        this.reviewAsset = {};
        this.supportingDocuments = { value: [] };
        /**
         *
         * @param query passes the query params to load assets
         */
        this.loadAssets = async (query = { count: 100, start: 0 }) => {
            this.assets.loading = true;
            const result = await api_1.AssetApprovalsEndpoint.list.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.assets = { error: result.code };
            }
            else {
                this.assets = { value: result.assets };
            }
        };
        this.saveAsset = async (asset) => {
            this.reviewAsset = { loading: true, status: ui_1.FormStatus.Saving };
            this.asset = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.asset.value
            };
            const result = await api_1.AssetApprovalsEndpoint.saveapproval.apiCall(null, {
                asset
            });
            if (api_1.isError(result)) {
                this.reviewAsset = { error: result.code, status: ui_1.FormStatus.Error };
                this.asset = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.asset.value
                };
                alert("Error in saving asset approval.");
                return false;
            }
            this.reviewAsset = { status: ui_1.FormStatus.Saved };
            this.asset = {
                status: ui_1.FormStatus.Saved,
                value: ramda_1.merge(asset, result.asset)
            };
            return result.asset;
        };
        this.rejectAsset = async (asset) => {
            this.reviewAsset = { loading: true, status: ui_1.FormStatus.Saving };
            this.asset = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.asset.value
            };
            const result = await api_1.AssetApprovalsEndpoint.saverejection.apiCall(null, {
                asset
            });
            if (api_1.isError(result)) {
                this.reviewAsset = { error: result.code, status: ui_1.FormStatus.Error };
                this.asset = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.asset.value
                };
                alert("Error in saving asset rejection.");
                return false;
            }
            this.reviewAsset = { status: ui_1.FormStatus.Saved };
            this.asset = {
                status: ui_1.FormStatus.Saved,
                value: ramda_1.merge(asset, result.asset)
            };
            return result.asset;
        };
        this.listSupportingDocuments = async (query = { count: 100, start: 0 }) => {
            this.supportingDocuments = Object.assign(Object.assign({}, this.supportingDocuments), { loading: true });
            const result = await api_1.AssetApprovalsEndpoint.listsupportingdocuments.apiCall({ query });
            if (api_1.isError(result)) {
                console.error("Error listing supporting documents", result);
                this.supportingDocuments.error = result.code;
            }
            else {
                this.supportingDocuments = Object.assign(Object.assign({}, this.supportingDocuments), { loading: false, value: result.supportingDocuments });
            }
        };
        this.updateSiteChangeRequest = async (asset, decision, reason) => {
            const result = await api_1.AssetApprovalsEndpoint.updatesitechangerequest.apiCall(null, { decision, reason, supportingDocumentsMeta: asset });
            if (api_1.isError(result)) {
                console.error("Error updating site change requeust", result);
                this.supportingDocuments.error = result.code;
            }
            else {
                this.supportingDocuments.error = "";
            }
        };
    }
}
__decorate([
    mobx_1.observable
], AssetApprovalsStore.prototype, "assets", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsStore.prototype, "asset", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsStore.prototype, "reviewAsset", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsStore.prototype, "supportingDocuments", void 0);
__decorate([
    mobx_1.action
], AssetApprovalsStore.prototype, "loadAssets", void 0);
__decorate([
    mobx_1.action
], AssetApprovalsStore.prototype, "saveAsset", void 0);
__decorate([
    mobx_1.action
], AssetApprovalsStore.prototype, "rejectAsset", void 0);
__decorate([
    mobx_1.action
], AssetApprovalsStore.prototype, "listSupportingDocuments", void 0);
__decorate([
    mobx_1.action
], AssetApprovalsStore.prototype, "updateSiteChangeRequest", void 0);
exports.assetApprovalsStore = new AssetApprovalsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/store.ts
// module id = 2801
// module chunks = 0